module.exports = __webpack_public_path__ + "img/blueDownArrowSmall.f25b8a68.svg";